import httpClient from '../../../../shared/services/http/http-client';
import { IImportedInvoice, IPostOAuthCode, IThirdPartyConnectionDetails, IThirdPartyConnectionDetailsCompany, IThirdPartyTenant } from './third-party-connection-details.model';

export default class ThirdPartyConnectionDetailsService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAvailableConnections(): Promise<IThirdPartyConnectionDetails[]> {
    return this.http.get(`third-party-connection/get-available-connections`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }


  async getConnection(thirdPartyConnectionProviderCode: string, queryString?: string): Promise<IThirdPartyConnectionDetails> {
    return this.http.get(`third-party-connection/get-connection?provider=${thirdPartyConnectionProviderCode}${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async exchangeCodeForToken(details: IPostOAuthCode): Promise<any> {
    return this.http.post(`third-party-connection/code`, details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async checkConnection(thirdPartyConnectionProviderCode: string): Promise<any> {
    return this.http.get(`third-party-connection/check-connection?provider=${thirdPartyConnectionProviderCode}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async revokeToken(thirdPartyConnectionProviderCode: string): Promise<any> {
    return this.http.get(`third-party-connection/revoke-token?provider=${thirdPartyConnectionProviderCode}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getConnectedCompanies(thirdPartyConnectionProviderCode: string): Promise<IThirdPartyConnectionDetailsCompany[]> {
    return this.http.get(`third-party-connection/get-companies?provider=${thirdPartyConnectionProviderCode}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getTransactions(reportPeriodId: string, thirdPartyConnectionProviderCode: string, queryString?: string): Promise<IImportedInvoice> {
    return this.http.get(`third-party-connection/get-transactions/${reportPeriodId}/${thirdPartyConnectionProviderCode}${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}